import React from "react";
import { Button, Typography } from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";

const sampleData = [
  ["question", "answer"],
  [
    "What is the refund policy?",
    "Our refund policy allows for a full refund within 30 days of purchase.",
  ],
  [
    "How do I reset my password?",
    "You can reset your password by clicking on the 'Forgot Password' link on the login page.",
  ],
  [
    "What are the system requirements?",
    "The system requires Windows 10 or later, or macOS 10.15 or later.",
  ],
];

const escapeCSV = (field: string) =>
  '"' + String(field).replace(/"/g, '""') + '"';

const handleDownloadSample = () => {
  const csvContent = sampleData
    .map((row) => row.map(escapeCSV).join(","))
    .join("\r\n");

  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const link = document.createElement("a");
  const url = URL.createObjectURL(blob);

  link.setAttribute("href", url);
  link.setAttribute("download", "sample_faqs.csv");
  link.style.visibility = "hidden";

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

const DownloadSampleCsvButton: React.FC = () => (
  <div
    style={{
      display: "flex",
      alignItems: "end",
      justifyContent: "center",
      gap: "10px",
    }}
  >
    <Typography sx={{ fontWeight: 500, my: 1, fontSize: 14 }}>
      Download Dummy CSV file
    </Typography>
    <Button
      variant="outlined"
      onClick={handleDownloadSample}
      sx={{
        border: "1px solid #000",
        color: "#000",
        textTransform: "none",
        "&:hover": {
          border: "1px solid #000",
          backgroundColor: "#f5f5f5",
        },
      }}
    >
      <DownloadIcon sx={{ mr: 1, fontSize: 20 }} />
      Download
    </Button>
  </div>
);

export default DownloadSampleCsvButton;
